import {BaseCart, CartItem, CartItemQuery} from '@eastsideco/salvo-ts';
import { settings } from './Settings';
export default class Cart extends BaseCart {
    constructor() {
        super();
    }
}

export const cart = new Cart();
cart.reload().catch((event: unknown | null) => {
    if (event instanceof Error) {
        // this.$log.error(event.message);
    }
});
